import { Guid } from "guid-typescript";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import ReactDOM from "react-dom";
import DynamicStyleManager from "../../../../shared/utilty/dynamic-style-manager";

interface TableHeaderProps {
  style?: any;
  writingMode?: "horizontal" | "vertical";
  columnTitles?: string;
  id?: string;
  hideOnMobileResolution?: boolean;
  wrapperClassname?: string;
  transformedOnMobileResolution?: boolean;
}

interface TableHeaderState {}

export class TableHeader extends PureComponent<TableHeaderProps, TableHeaderState> {
  private uniqueKey = Guid.create();

  private style = new DynamicStyleManager(`ktableheader_${this.uniqueKey}`);

  constructor(props: TableHeaderProps) {
    super(props);
    this.state = {};
  }

  componentDidMount(): void {
    const tableHeader = ReactDOM.findDOMNode(this) as Element;
    const table = tableHeader?.parentElement;
    if (table && this.props.hideOnMobileResolution === true) {
      table.classList.add("ktableheader_without-title");
    }
    if (this.props.transformedOnMobileResolution === true) {
      this.setDynamicStyle();
    }
  }

  componentDidUpdate() {
    if (this.props.transformedOnMobileResolution === true) {
      this.setDynamicStyle();
    }
  }

  componentWillUnmount() {
    this.style.removeStyle();
  }

  getDynamicCss = (): string => {
    const className: string = this.props.wrapperClassname;
    if (!className || className.length === 0) {
      return "";
    }
    let result = "";
    const {
      fontSize,
      fontWeight,
      lineHeight,
      color,
      backgroundColor,
      fontFamily,
      textDecoration,
      textTransform,
      fontStyle,
      letterSpacing
    } = this.props.style;

    if (
      fontSize ||
      fontWeight ||
      lineHeight ||
      color ||
      backgroundColor ||
      fontFamily ||
      textDecoration ||
      textTransform ||
      fontStyle ||
      letterSpacing
    ) {
      result += `${className} td::before {
        ${fontSize ? `font-size: ${fontSize};` : ""}
        ${fontWeight ? `font-weight: ${fontWeight};` : ""}
        ${lineHeight ? `line-height: ${lineHeight};` : ""}
        ${color ? `color: ${color};` : ""}
        ${backgroundColor ? `background-color: ${backgroundColor};` : ""}
        ${fontFamily ? `font-family: ${fontFamily};` : ""}
        ${textDecoration ? `text-decoration: ${textDecoration};` : ""}
        ${textTransform ? `text-transform: ${textTransform};` : ""}
        ${fontStyle ? `font-style: ${fontStyle};` : ""}
        ${letterSpacing ? `letter-spacing: ${letterSpacing};` : ""}
      }`;
    }

    return result;
  };

  setDynamicStyle = () => {
    this.style.setDynamicCss(this.getDynamicCss());
  };

  getProps = () => {
    const props: any = _.clone(this.props);
    if (props?.style?.display) {
      delete props.style.display;
    }
    return props;
  };

  render(): ReactNode {
    return <thead {...this.getProps()}></thead>;
  }
}
